import React from 'react';
import { useTranslation } from 'react-i18next';

export const NoStatisticsSummaryView: React.FunctionComponent = () => {
  const { t } = useTranslation();
  return (
    <div className="flexSelfCenter alert alert-info fs16 p25 max-width-400">
      {t('INVESTIGATE_TOOLS.SUMMARY_REPORT.NO_STATISTICS_VIEW')}
    </div>
  );
};
